// TecnicaTabXL - Sprint 44 Fase 3 Vista 3.
// Tab "Informacion tecnica": marca, SKU, peso (kg), volumen (m3).
// Los numericos usan XLInput type=number para preservar el comportamiento
// legacy (step 0.001 / 0.0001). El backend coercea string -> float igual.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLInput from '../../../components/xl/XLInput';

const CSS_ID = 'xl-prod-tecnica-css';
const CSS = `
.xl-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  font-family: var(--xl-font-sans);
}
@media (max-width: 720px) { .xl-form-grid { grid-template-columns: 1fr } }
`;

export default function TecnicaTabXL({ form, set, errors = {} }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  return (
    <div className="xl-form-grid">
      <XLInput
        label="Marca"
        value={form.marca || ''}
        onChange={(e) => set('marca', e.target.value)}
        error={errors.marca}
      />
      <XLInput
        label="SKU"
        value={form.sku || ''}
        onChange={(e) => set('sku', e.target.value)}
        error={errors.sku}
      />
      <XLInput
        label="Peso (kg)"
        type="number"
        min="0"
        step="0.001"
        value={form.peso_kg === null || form.peso_kg === undefined ? '' : form.peso_kg}
        onChange={(e) => set('peso_kg', e.target.value)}
        error={errors.peso_kg}
        hint="Usado para envios y calculo de volumen."
      />
      <XLInput
        label="Volumen (m3)"
        type="number"
        min="0"
        step="0.0001"
        value={form.volumen_m3 === null || form.volumen_m3 === undefined ? '' : form.volumen_m3}
        onChange={(e) => set('volumen_m3', e.target.value)}
        error={errors.volumen_m3}
        hint="Usado para distribucion de costos por volumen en Importacion USA."
      />
    </div>
  );
}
